var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"cplug-logo ma-5"},[_c('v-img',{attrs:{"src":require('@/assets/img/connectplug-logo-branca.png'),"max-width":"300px"}})],1),_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('router-view'),_c('notification-handler')],1)],1),_c('div',{staticClass:"full-page-background",style:({
            background:
                'url(' + require('@/assets/img/background.png') + ')',
        })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }